import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import { useEffect, useState } from "react";
import useTranslator from "../../hooks/useTranslator";
const IncomeSourceCard = ({
  userId,
  amount,
  type,
  selectedSource = [],
  changeSelectedSource,
}) => {
  const { _t } = useTranslator();
  const [isActive, setIsActive] = useState(selectedSource?.includes(type));

  useEffect(() => {
    setIsActive(selectedSource?.includes(type));
  }, [selectedSource]);

  const handleChange = () => {
    changeSelectedSource(userId, type);
  };

  return (
    <div
      className={`income-source-card-wrapper ${
        isActive ? "income-source-card-wrapper-active" : ""
      }`}
      onClick={handleChange}
    >
      <div className="d-flex align-items-center about-source">
        <div className="default-checkbox d-flex align-items-center justify-content-center">
          {isActive && <CheckOutlinedIcon />}
        </div>
        <div className="d-flex flex-column">
          <h4>
            {type.startsWith("payslip:")
              ? (() => {
                  const temp = type.split(":");
                  const rawDate = temp[1]?.trim();

                  const parts = rawDate.split(" ");
                  let month = parts[0].replace(",", "");
                  const rest = parts.slice(1).join(" ");

                  const hasComma = parts[0].includes(",");

                  return `${_t(temp[0])}: ${_t(month)}${
                    hasComma ? "," : ""
                  } ${rest}`.trim();
                })()
              : _t(type)}
          </h4>
          <h6>€{amount}</h6>
        </div>
      </div>
    </div>
  );
};

export default IncomeSourceCard;
